import { defineMessages } from 'react-intl';

export default defineMessages({
  // Weekdays

  sundayShort: {
    id: 'common.calendar.sundayShort',
    defaultMessage: 'Dom',
    description: 'Label for the short version of sunday',
  },
  mondayShort: {
    id: 'common.calendar.mondayShort',
    defaultMessage: 'Lun',
    description: 'Label for the short version of monday',
  },
  tuesdayShort: {
    id: 'common.calendar.tuesdayShort',
    defaultMessage: 'Mar',
    description: 'Label for the short version of tuesday',
  },
  wednesdayShort: {
    id: 'common.calendar.wednesdayShort',
    defaultMessage: 'Mer',
    description: 'Label for the short version of wednesday',
  },
  thursdayShort: {
    id: 'common.calendar.thursdayShort',
    defaultMessage: 'Gio',
    description: 'Label for the short version of thursday',
  },
  fridayShort: {
    id: 'common.calendar.fridayShort',
    defaultMessage: 'Ven',
    description: 'Label for the short version of friday',
  },
  saturdayShort: {
    id: 'common.calendar.saturdayShort',
    defaultMessage: 'Sab',
    description: 'Label for the short version of saturday',
  },

  // Months
  january: {
    id: 'common.calendar.january',
    defaultMessage: 'Gennaio',
    description: 'Month name: january',
  },
  february: {
    id: 'common.calendar.february',
    defaultMessage: 'Febbraio',
    description: 'Month name: february',
  },
  march: {
    id: 'common.calendar.march',
    defaultMessage: 'Marzo',
    description: 'Month name: march',
  },
  april: {
    id: 'common.calendar.april',
    defaultMessage: 'Aprile',
    description: 'Month name: april',
  },
  may: {
    id: 'common.calendar.may',
    defaultMessage: 'Maggio',
    description: 'Month name: may',
  },
  june: {
    id: 'common.calendar.june',
    defaultMessage: 'Giugno',
    description: 'Month name: june',
  },
  july: {
    id: 'common.calendar.july',
    defaultMessage: 'Luglio',
    description: 'Month name: july',
  },
  august: {
    id: 'common.calendar.august',
    defaultMessage: 'Agosto',
    description: 'Month name: august',
  },
  september: {
    id: 'common.calendar.september',
    defaultMessage: 'Settembre',
    description: 'Month name: september',
  },
  october: {
    id: 'common.calendar.october',
    defaultMessage: 'Ottobre',
    description: 'Month name: october',
  },
  november: {
    id: 'common.calendar.november',
    defaultMessage: 'Novembre',
    description: 'Month name: november',
  },
  december: {
    id: 'common.calendar.december',
    defaultMessage: 'Dicembre',
    description: 'Month name: december',
  },

  // Buttons
  selectYearLabel: {
    id: 'common.calendar.selectYearLabel',
    defaultMessage: 'Seleziona anno',
    description:
      'Title of the "select year" page shown in the calendar picker view (mobile)',
  },
});
